import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AmbienteLoginService } from '../services/ambiente/ambiente-login.service';

@Injectable()
export class AmbienteBancoInterceptor implements HttpInterceptor {
  constructor(private ambienteLogin: AmbienteLoginService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.ambienteLogin.permitirTrocaAmbiente || !this.ehApiDoSistema(request.url)) {
      return next.handle(request);
    }

    return next.handle(request.clone({
      setHeaders: {
        'X-Ambiente-Banco': this.ambienteLogin.ambiente,
      },
    }));
  }

  private ehApiDoSistema(url: string): boolean {
    return this.ehUrlDaApi(url, environment.apiUrl)
      || this.ehUrlDaApi(url, environment.apiOperacionalUrl)
      || this.ehUrlDaApi(url, environment.apiExecutivoUrl);
  }

  private ehUrlDaApi(url: string, apiUrl?: string): boolean {
    if (!apiUrl) {
      return false;
    }
    const base = apiUrl.replace(/\/$/, '');
    return url.startsWith(apiUrl) || url.startsWith(base);
  }
}
